import { SidebarProvider } from '@/components/ui/sidebar'
import { AdminSidebar } from '@/components/AdminSidebar'
import { TopBar } from '@/components/TopBar'
import { useSessionTimeout } from '@/hooks/useSessionTimeout'
import { AnimatePresence, motion } from 'motion/react'
import { useLocation, Outlet } from 'react-router-dom'
import { useUIStore } from '@/stores/uiStore'

export function AdminLayout() {
  useSessionTimeout() // 2h inactivity auto-logout -- ONLY runs in authenticated context

  const location = useLocation()
  const sidebarOpen = useUIStore((s) => s.sidebarOpen)
  const setSidebarOpen = useUIStore((s) => s.setSidebarOpen)

  return (
    <SidebarProvider open={sidebarOpen} onOpenChange={setSidebarOpen}>
      <AdminSidebar />
      <div className="flex flex-1 flex-col">
        <TopBar />
        <main className="flex-1 overflow-auto p-6">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeOut' }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </SidebarProvider>
  )
}
